module.exports = __webpack_public_path__ + "static/media/  (144).fa9cecc0.jpg";